/* global google */
export default {
  init() {
    // JavaScript to be fired on the home page
    /*
     *  new_map
     *
     *  This function will render a Google Map onto the selected jQuery element
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	$el (jQuery element)
     *  @return	n/a
     */

    function new_map($el) {

        // var
        var $markers = $el.find('.marker');
  
  
        // vars
        var args = {
          zoom: 12,
          center: new google.maps.LatLng(0, 0),
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          disableDefaultUI: true,
          zoomControl: true,
          styles: [{
            featureType: 'all',
            elementType: 'geometry.fill',
            stylers: [{
                weight: '1.27',
              }, {
                lightness: '27',
              }],
            }, {
                featureType: 'all',
                elementType: 'geometry.stroke',
                stylers: [{
                    color: '#9c9c9c',
                }],
            }, {
                featureType: 'all',
                elementType: 'labels.text',
                stylers: [{
                    visibility: 'on',
                }, {
                    lightness: '29',
                }, {
                    saturation: '-100',
                }],
            }, {
                featureType: 'landscape',
                elementType: 'geometry.fill',
                stylers: [{
                    color: '#ffffff',
                }],
            }, {
                featureType: 'landscape.man_made',
                elementType: 'geometry.fill',
                stylers: [{
                    color: '#ffffff',
                }],
            }, {
                featureType: 'poi',
                elementType: 'all',
                stylers: [{
                    visibility: 'simplified',
                }],
            }, {
                featureType: 'poi',
                elementType: 'labels.icon',
                stylers: [{
                    visibility: 'off',
                }],
            }, {
                featureType: 'poi.park',
                elementType: 'all',
                stylers: [{
                    visibility: 'simplified',
                }, {
                    color: '#dbe8d4',
                }],
            }, {
                featureType: 'road',
                elementType: 'all',
                stylers: [{
                    saturation: '-86',
                }, {
                    lightness: '-14',
                }, {
                    visibility: 'on',
                }, {
                    gamma: '1.75',
                }, {
                    weight: '0.53',
                }],
            }, {
                featureType: 'road',
                elementType: 'geometry.fill',
                stylers: [{
                    visibility: 'on',
                }, {
                    weight: '0.5',
                }, {
                    color: '#eeeeee',
                }],
            }, {
                featureType: 'road',
                elementType: 'geometry.stroke',
                stylers: [{
                    visibility: 'off',
                }, {
                    weight: '0.01',
                }],
            }, {
                featureType: 'road.highway',
                elementType: 'all',
                stylers: [{
                    visibility: 'simplified',
                }],
            }, {
                featureType: 'road.arterial',
                elementType: 'labels.icon',
                stylers: [{
                    visibility: 'off',
                }],
            }, {
                featureType: 'water',
                elementType: 'geometry.fill',
                stylers: [{
                    color: '#a6cbd3',
                }],
            }],
        };
  
  
        // create map	        	
        var map = new google.maps.Map($el[0], args);
  
  
        // add a markers reference
        map.markers = [];
  
  
        // add markers
        $markers.each(function () {
  
          add_marker($(this), map);
  
        });
  
  
        // center map
        center_map(map);
  
  
        // return
        return map;
  
      }
  
      /*
       *  add_marker
       *
       *  This function will add a marker to the selected Google Map
       *
       *  @type	function
       *  @date	8/11/2013
       *  @since	4.3.0
       *
       *  @param	$marker (jQuery element)
       *  @param	map (Google Map object)
       *  @return	n/a
       */
  
      function add_marker($marker, map) {
  
        // var
        var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
  
        var icon = {
          url: $marker.attr('data-icon'),
          anchor: new google.maps.Point(30,60),
          scaledSize: new google.maps.Size(60,60),
        }
  
        // create marker
        var marker = new google.maps.Marker({
          position: latlng,
          map: map,
          icon: icon,
          draggable: false,
          animation: google.maps.Animation.DROP,
        });
  
        // add to array
        map.markers.push(marker);
  
        // if marker contains HTML, add it to an infoWindow
        if ($marker.html()) {
          // create info window
          var infowindow = new google.maps.InfoWindow({
            content: $marker.html(),
          });
  
          // show info window when marker is clicked
          google.maps.event.addListener(marker, 'click', function () {
  
            infowindow.open(map, marker);
  
          });
        }
  
      }
  
      /*
       *  center_map
       *
       *  This function will center the map, showing all markers attached to this map
       *
       *  @type	function
       *  @date	8/11/2013
       *  @since	4.3.0
       *
       *  @param	map (Google Map object)
       *  @return	n/a
       */
  
      function center_map(map) {
  
        // vars
        var bounds = new google.maps.LatLngBounds();
  
        // loop through all markers and create bounds
        $.each(map.markers, function (i, marker) {
  
          var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
  
          bounds.extend(latlng);
  
        });
  
        // only 1 marker?
        if (map.markers.length == 1) {
          // set center of map
          map.setCenter(bounds.getCenter());
          map.setZoom(14);
        } else {
          // fit to bounds
          map.fitBounds(bounds);
          map.setZoom(14);
        }
  
        // map.setCenter( new google.maps.LatLng(map.markers[0].position.lat(), map.markers[0].position.lng()) );
        // map.setZoom(14);
  
      }
  
      /*
       *  document ready
       *
       *  This function will render each map when the document is ready (page has loaded)
       *
       *  @type	function
       *  @date	8/11/2013
       *  @since	5.0.0
       *
       *  @param	n/a
       *  @return	n/a
       */
      // global var
      $('.map').each(function () {
        new_map($(this));
      });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateLocation.js